import { StringHelper } from "../../../utilities/contracts/string-helper";

export class LoadSummaryResponse {
  readonly tenantId?: string;
  readonly loadId?: string;
  readonly submissionReadyCount?: number;
  readonly validationErrorCount?: number;
  readonly validationWarningCount?: number;
  readonly recordExistsCount?: number;
  readonly submissionCount?: number;
  readonly submissionFailedCount?: number;
  readonly totalCount?: number;
  readonly loadCreateTs?: string;

  constructor(options: Partial<LoadSummaryResponse> = {}) {
    this.tenantId = StringHelper.clean(options.tenantId);
    this.loadId = StringHelper.clean(options.loadId);
    this.submissionReadyCount = options.submissionReadyCount;
    this.validationErrorCount = options.validationErrorCount;
    this.validationWarningCount = options.validationWarningCount;
    this.recordExistsCount = options.recordExistsCount;
    this.submissionCount = options.submissionCount;
    this.submissionFailedCount = options.submissionFailedCount;
    this.totalCount = options.totalCount;
    this.loadCreateTs = StringHelper.clean(options.loadCreateTs);
  }
}
